import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { WMC_ROUTE_PATHS, WMC_SCOPE } from './config';

export const WITHDRAWAL_METHOD_CONFIG_ROUTES: TApplicationRoute[] = [
  {
    id: 'withdrawal-method-config',
    path: WMC_ROUTE_PATHS.list,
    component: lazy(() => import('./pages/wmc-list-page')),
    layout: 'default',
    permissions: { scopes: [WMC_SCOPE] },
    menu: {
      title: 'Withdrawal Config',
    },
  },
  {
    id: 'withdrawal-method-config-new',
    path: WMC_ROUTE_PATHS.new,
    component: lazy(() => import('./pages/wmc-form-page')),
    layout: 'default',
    permissions: { scopes: [WMC_SCOPE] },
  },
  {
    id: 'withdrawal-method-config-edit',
    path: WMC_ROUTE_PATHS.edit,
    component: lazy(() => import('./pages/wmc-form-page')),
    layout: 'default',
    permissions: { scopes: [WMC_SCOPE] },
  },
];
